import { authFetch, authHeaders, resolveApiBaseUrl } from '../auth';
import { apiUrl } from './http';

export const disputesMethods = {
// Create dispute
  async createDispute(orderId, reason, comment, photos = []) {
    try {
      const result = await this.makeAPICall('/disputes/create/', 'POST', {
        order_id: orderId,
        reason: reason,
        comment: comment,
        photos: photos
      });

      return {
        success: true,
        message: result.message,
        dispute_id: result.dispute_id
      };
    } catch (error) {
      console.error('Failed to create dispute:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Create dispute with file uploads
  async createDisputeWithFiles(formData) {
    try {
      const response = await authFetch(`${this.baseURL}/disputes/create/`, {
        method: 'POST',
        headers: authHeaders(),
        body: formData
        // Don't set Content-Type header - let browser set it with boundary
      });

      if (!response.ok) {
        if (response.status === 413) {
          throw new Error('Upload too large. Use up to 5 images, max 5MB each.');
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return {
        success: true,
        message: result.message,
        dispute_id: result.dispute_id,
        uploaded_files: result.uploaded_files
      };
    } catch (error) {
      console.error('Failed to create dispute with files:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Resolve dispute
  async resolveDispute(orderId, resolution) {
    try {
      const result = await this.makeAPICall('/disputes/resolve/', 'POST', {
        order_id: orderId,
        resolution: resolution // 'refund' or 'replacement'
      });

      return {
        success: true,
        message: result.message,
        resolution: result.resolution,
        new_status: result.new_status
      };
    } catch (error) {
      console.error('Failed to resolve dispute:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};
